import { Box, Divider, Stack } from '@mui/material';
import React, { FC } from 'react';
import Typography from '../../components/Typography/Typography';

type ListItemProps = {
  field: string;
  value: string;
};

const ListItem: FC<ListItemProps> = ({ field, value }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={4} my={1.5}>
    <Typography weight={400} size={14} sx={{ color: '#5C5C5C' }}>
      {field}
    </Typography>
    <Typography weight={500} size={14} maxWidth="70%" textAlign="right" color="#1C1951">
      {value || '--'}
    </Typography>
  </Stack>
);

export interface Field {
  field: string;
  value: string;
}

type Props = {
  fields: Field[];
};

const FieldList: FC<Props> = ({ fields }) => (
  <Box pr={1.5} pl={1.5}>
    {fields.map((field, index) => (
      <React.Fragment key={field.field}>
        <ListItem key={field.field} {...field} />
        <Divider sx={{ borderStyle: 'dashed', borderColor: '#E3E3E3' }} />
      </React.Fragment>
    ))}
  </Box>
);

export default FieldList;
